<template>
  <div class="team">
    <div class="box-1 container">
      <div style="height: 60px"></div>
      <div class="info-box flex">
        <el-image 
          style="width: 300px; height: 300px"
          :src="isHead(info.img)" 
          fit="cover">
          <el-image 
            style="width: 300px; height: 300px"
            :src="isHead()" 
            fit="cover">
          </el-image>
        </el-image>
        <div class="content">
          <div class="title">{{info.name}}</div>
          <div style="height: 30px"></div>
          <div v-html="info.content"></div>
        </div>
      </div>
      <div style="height: 80px"></div>
    </div>
    <div class="box-2">
      <div class="container">
        <div style="height: 100px"></div>
        <div class="tips flex">
          <div class="icon">
            <img :src="require('@/assets/5101/icon_19.png')" alt="">
          </div>
          <div class="txt">更多社团</div>
        </div>
        
      </div>
      <div class="items flex">
        <div class="item flex" v-for="v in listData" :key="v.id" @click="jump(v)">
          <div class="cover">
            <el-image 
              style="width: 100%; height: 120px"
              :src="isHead(v.img)" 
              fit="cover">
              <template #placeholder>
                <el-image 
                  style="width: 100%; height: 120px"
                  :src="isHead()" 
                  fit="cover">
                </el-image>
              </template>
            </el-image>
          </div>
          <div class="info-box">
            <div class="title ellipsis">{{v.name}}</div>
            <div class="txt ellipsis">负责人：{{v.linkman}}</div>
            <div class="txt ellipsis">联系电话：{{v.tel}}</div>
            <div class="more flex">
              <div class="p1">查看详情</div>
              <div class="icon">
                <img :src="require('@/assets/5101/icon_5.png')" alt="">
              </div>
            </div>
          </div>
        </div>

        
      </div>
      <div style="height: 100px"></div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue"
import { useRoute, useRouter } from "vue-router"
import { api } from "@/api"
import { isHead } from "@/tools"
export default {
  name: "team",
  setup() {
    const route = useRoute()
    const Router = useRouter()
    let initData = reactive({
      info: "",
      listData: ""
    })
    api("get", "getAppAssociation", {id: route.query.id})
      .then(res => {
        if(res.code === 1200) {
          initData.info = res.data
        }
      })
    api("get", "getAppAssociationList", {type: 1, pageSize: 6})
      .then(res => {
        if(res.code === 1200) {
          initData.listData = res.data
        }
      })
    function jump(row) {
      Router.push({
        path: "/show/team",
        query: {
          id: row.id
        }
      })
    }
    return {
      ...toRefs(initData),
      isHead,
      jump
    }
  }
}
</script>
<style>
.header {
  border-bottom: 2px solid #F6F6F6;
  box-sizing: border-box;
}
</style>
<style lang="less" scoped>
.box-1 {
  .content {
    margin-left: 30px;
    flex: 1;
    .title {
      font-size: 24px;
      font-weight: bold;
      line-height: 1;
    }
  }
}
.box-2 {
  background-color: #F6F6F6;
  .tips {
    align-items: center;
    padding-bottom: 20px;
    position: relative;
    border-bottom: 1px solid #C5C5C5;
    &::after {
      content: "";
      height: 3px;
      width: 140px;
      background-color: #1A2E43;
      position: absolute;
      left: 0;
      bottom: -2px;
      border-radius: 2px;
    }
    .icon {
      font-size: 0;
    }
    .txt {
      font-size: 26px;
      font-weight: bold;
      margin-left: 12px;
      line-height: 1;
    }
  }
  .items {
    width: 1248px;
    margin: 0 auto;
    flex-wrap: wrap;
    margin-top: 35px;
    .item {
      width: 384px;
      height: 160px;
      margin: 24px 0 0 24px;
      background-color: #fff;
      padding: 20px 20px 20px 15px;
      box-sizing: border-box;
      transition: .2s;
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
        background-color: #1A2E43;
        .title {
          color: #fff;
        }
        .txt {
          color: #fff;
          opacity: .9;
        }
      }
      .cover {
        width: 120px;
        display: flex;
        align-items: center;
        font-size: 0;
        .el-image {
          border-radius: 50%;
          overflow: hidden;
        }
      }
      .info-box {
        margin-left: 15px;
        .title {
          font-weight: bold;
        }
        .txt {
          font-size: 14px;
          color: #8C96A1;
          margin-top: 12px;
        }
      }
      .more {
        margin-top: 15px;
        .p1 {
          font-size: 14px;
          color: #10BB58;
        }
        .icon {
          margin-left: 10px;
          
        }
      }
    }
  }
}
</style>